module.exports = __webpack_public_path__ + "img/spoken_read_stop_dis.4544d677.svg";